import { useEpisodeOtt } from './use-episode-ott';

export function usePrerollsDuration(contentId: string) {
    const episode = useEpisodeOtt(contentId);

    return episode?.onlineStreams?.streams?.[0]?.streamMeta?.prerollsDuration || 0;
}
